import _implicitStylesheets from "./competenciesV2.css";
import _implicitScopedStylesheets from "./competenciesV2.scoped.css?scoped=true";
import _i18nLink from "i18n/link";
import _axIcon from "ax/icon";
import _axImage from "ax/image";
import _wdsModal from "wds/modal";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<button type="button" role="tab"${"a0:id"}${"c0"}${"a0:data-tab"}${"a0:data-testid"}${"a0:aria-selected"}${"a0:aria-controls"}${"a0:tabindex"}${2}>${"t1"}</button>`;
const $fragment2 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment3 = parseFragment`<th scope="col" class="col-category${0}"${2}><span data-testid="category-column-header"${3}>${"t2"}</span></th>`;
const $fragment4 = parseFragment`<p class="tooltip-intro${0}"${2}>${"t1"}</p>`;
const $fragment5 = parseFragment`<div class="tooltip-level${0}"${2}><div class="level-header${0}"${2}><img class="level-icon-tooltip${0}" src="/assets/images/competency-accredited.svg" alt="" aria-hidden="true"${2}><span class="level-name-tooltip${0}"${2}>${"t4"}</span></div><p class="level-desc${0}"${2}>${"t6"}</p></div>`;
const $fragment6 = parseFragment`<div class="tooltip-level${0}"${2}><div class="level-header${0}"${2}><img class="level-icon-tooltip${0}" src="/assets/images/competency-expert.svg" alt="" aria-hidden="true"${2}><span class="level-name-tooltip${0}"${2}>${"t4"}</span></div><p class="level-desc${0}"${2}>${"t6"}</p></div>`;
const $fragment7 = parseFragment`<p class="tooltip-text${0}"${2}>${"t1"}</p>`;
const $fragment8 = parseFragment`<p class="tooltip-text${0}"${2}>${"t1"}</p>`;
const $fragment9 = parseFragment`<p class="tooltip-text${0}"${2}>${"t1"}</p>`;
const $fragment10 = parseFragment`<span class="competency-name${0}" data-testid="competency-name"${2}>${"t1"}</span>`;
const $fragment11 = parseFragment`<span class="cell-label${0}"${2}>${"t1"}</span>`;
const $fragment12 = parseFragment`<img class="level-icon${0}" src="/assets/images/competency-expert.svg" alt="" aria-hidden="true"${2}>`;
const $fragment13 = parseFragment`<img class="level-icon${0}" src="/assets/images/competency-accredited.svg" alt="" aria-hidden="true"${2}>`;
const $fragment14 = parseFragment`<span class="level-text${0}"${2}>${"t1"}</span>`;
const $fragment15 = parseFragment`<td class="col-number${0}" data-testid="recent-projects"${2}><span class="cell-label${0}"${2}>${"t2"}</span><span class="cell-value${0}"${2}>${"t4"}</span></td>`;
const $fragment16 = parseFragment`<td class="col-number${0}" data-testid="avg-csat"${2}><span class="cell-label${0}"${2}>${"t2"}</span><span class="cell-value${0}"${2}>${"t4"}</span></td>`;
const $fragment17 = parseFragment`<span class="cell-label${0}"${2}>${"t1"}</span>`;
const $fragment18 = parseFragment`<button class="cert-button${0}" data-testid="cert-button-category"${"a0:data-competency-id"}${"a0:aria-label"}${2}>${"t1"}</button>`;
const $fragment19 = parseFragment`<td class="col-category sub-name${0}" data-testid="specialization-name"${2}><span class="visually-hidden${0}"${2}>${"t2"}</span>${"t3"}</td>`;
const $fragment20 = parseFragment`<td class="col-level col-level-empty${0}"${2}></td>`;
const $fragment21 = parseFragment`<td class="col-number${0}"${2}><span class="cell-label${0}"${2}>${"t2"}</span><span class="cell-value${0}"${2}>${"t4"}</span></td>`;
const $fragment22 = parseFragment`<td class="col-number${0}"${2}><span class="cell-label${0}"${2}>${"t2"}</span><span class="cell-value${0}"${2}>${"t4"}</span></td>`;
const $fragment23 = parseFragment`<span class="cell-label${0}"${2}>${"t1"}</span>`;
const $fragment24 = parseFragment`<button class="cert-button${0}" data-testid="cert-button-subcategory"${"a0:data-competency-id"}${"a0:data-subcategory-name"}${"a0:aria-label"}${2}>${"t1"}</button>`;
const $fragment25 = parseFragment`<h3${3}>${"t1"}</h3>`;
const $fragment26 = parseFragment`<h3${3}>${"t1"}</h3>`;
const $fragment27 = parseFragment`<p class="modal-description${0}"${2}>${"t1"}</p>`;
const $fragment28 = parseFragment`<div class="modal-total${0}"${2}><strong${3}>${"t2"}</strong><span class="modal-total-value${0}"${2}>${"t4"}</span></div>`;
const $fragment29 = parseFragment`<thead${3}><tr${3}><th scope="col" class="cert-name-col${0}"${2}>${"t3"}</th><th scope="col" class="cert-total-col${0}"${2}>${"t5"}</th></tr></thead>`;
const $fragment30 = parseFragment`<tr${3}><td class="cert-name-col${0}"${2}>${"t2"}</td><td class="cert-total-col${0}"${2}>${"t4"}</td></tr>`;
const $fragment31 = parseFragment`<p class="modal-empty-state${0}"${2}>${"t1"}</p>`;
const $fragment32 = parseFragment`<section class="metrics-modal-section${0}"${2}><h4 class="metrics-modal-heading${0}"${2}>${"t2"}</h4><p class="metrics-modal-text${0}"${2}>${"t4"}</p><div class="metrics-modal-level${0}"${2}><div class="metrics-modal-level-header${0}"${2}><img class="metrics-modal-level-icon${0}" src="/assets/images/competency-accredited.svg" alt="" aria-hidden="true"${2}><span class="metrics-modal-level-name${0}"${2}>${"t9"}</span></div><p class="metrics-modal-text${0}"${2}>${"t11"}</p></div><div class="metrics-modal-level${0}"${2}><div class="metrics-modal-level-header${0}"${2}><img class="metrics-modal-level-icon${0}" src="/assets/images/competency-expert.svg" alt="" aria-hidden="true"${2}><span class="metrics-modal-level-name${0}"${2}>${"t16"}</span></div><p class="metrics-modal-text${0}"${2}>${"t18"}</p></div></section>`;
const $fragment33 = parseFragment`<section class="metrics-modal-section${0}"${2}><h4 class="metrics-modal-heading${0}"${2}>${"t2"}</h4><p class="metrics-modal-text${0}"${2}>${"t4"}</p></section>`;
const $fragment34 = parseFragment`<section class="metrics-modal-section${0}"${2}><h4 class="metrics-modal-heading${0}"${2}>${"t2"}</h4><p class="metrics-modal-text${0}"${2}>${"t4"}</p></section>`;
const $fragment35 = parseFragment`<section class="metrics-modal-section${0}"${2}><h4 class="metrics-modal-heading${0}"${2}>${"t2"}</h4><p class="metrics-modal-text${0}"${2}>${"t4"}</p></section>`;
const stc0 = {
  classMap: {
    "competencies-container": true
  },
  attrs: {
    "data-testid": "competencies-container",
    "data-scroll-to": "competencies-table"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "competencies-intro": true
  },
  attrs: {
    "data-testid": "competencies-intro"
  },
  key: 2
};
const stc2 = {
  "data-testid": "competencies-intro-link"
};
const stc3 = {
  classMap: {
    "tab-bar": true
  },
  key: 4
};
const stc4 = {
  "tab-navigation": true
};
const stc5 = {
  classMap: {
    "metrics-info-row": true
  },
  key: 8
};
const stc6 = {
  "metrics-info-trigger": true
};
const stc7 = {
  classMap: {
    "metrics-info-icon": true
  },
  props: {
    "icon": "info",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 10
};
const stc8 = {
  "table-wrapper": true
};
const stc9 = {
  classMap: {
    "table-container": true
  },
  key: 15
};
const stc10 = {
  "competencies-table": true
};
const stc11 = {
  key: 17
};
const stc12 = {
  key: 18
};
const stc13 = {
  classMap: {
    "col-level": true
  },
  attrs: {
    "scope": "col"
  },
  key: 21
};
const stc14 = {
  classMap: {
    "info-tooltip-wrapper": true
  },
  key: 22
};
const stc15 = {
  "info-button": true
};
const stc16 = {
  classMap: {
    "tooltip-icon": true
  },
  props: {
    "icon": "info",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 24
};
const stc17 = {
  "custom-tooltip": true
};
const stc18 = {
  "tooltip-close": true
};
const stc19 = {
  props: {
    "icon": "close",
    "size": "small",
    "theme": "blue"
  },
  key: 28
};
const stc20 = {
  classMap: {
    "col-number": true
  },
  attrs: {
    "scope": "col"
  },
  key: 35
};
const stc21 = {
  classMap: {
    "info-tooltip-wrapper": true
  },
  key: 36
};
const stc22 = {
  classMap: {
    "tooltip-icon": true
  },
  props: {
    "icon": "info",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 38
};
const stc23 = {
  props: {
    "icon": "close",
    "size": "small",
    "theme": "blue"
  },
  key: 42
};
const stc24 = {
  classMap: {
    "col-number": true
  },
  attrs: {
    "scope": "col"
  },
  key: 45
};
const stc25 = {
  classMap: {
    "info-tooltip-wrapper": true
  },
  key: 46
};
const stc26 = {
  classMap: {
    "tooltip-icon": true
  },
  props: {
    "icon": "info",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 48
};
const stc27 = {
  props: {
    "icon": "close",
    "size": "small",
    "theme": "blue"
  },
  key: 52
};
const stc28 = {
  classMap: {
    "col-number": true
  },
  attrs: {
    "scope": "col"
  },
  key: 55
};
const stc29 = {
  classMap: {
    "info-tooltip-wrapper": true
  },
  key: 56
};
const stc30 = {
  classMap: {
    "tooltip-icon": true
  },
  props: {
    "icon": "info",
    "size": "small",
    "ariaHidden": "true"
  },
  key: 58
};
const stc31 = {
  "custom-tooltip": true,
  "align-right": true
};
const stc32 = {
  props: {
    "icon": "close",
    "size": "small",
    "theme": "blue"
  },
  key: 62
};
const stc33 = {
  "category-group": true
};
const stc34 = {
  classMap: {
    "main-row": true
  },
  key: 66
};
const stc35 = {
  classMap: {
    "col-category": true
  },
  key: 67
};
const stc36 = {
  "expand-button": true
};
const stc37 = {
  "icon": "chevronup",
  "size": "small",
  "ariaHidden": "true"
};
const stc38 = {
  classMap: {
    "col-level": true
  },
  attrs: {
    "data-testid": "competency-level"
  },
  key: 73
};
const stc39 = {
  classMap: {
    "cell-value": true
  },
  key: 76
};
const stc40 = {
  classMap: {
    "col-number": true
  },
  attrs: {
    "data-testid": "certifications"
  },
  key: 90
};
const stc41 = {
  classMap: {
    "cell-value": true
  },
  key: 93
};
const stc42 = {
  "sub-row": true
};
const stc43 = {
  "data-testid": "specialization-row"
};
const stc44 = {
  classMap: {
    "col-number": true
  },
  key: 108
};
const stc45 = {
  classMap: {
    "cell-value": true
  },
  key: 111
};
const stc46 = {
  classMap: {
    "empty-state": true,
    "tab-empty-state": true
  },
  attrs: {
    "data-testid": "tab-empty-state"
  },
  key: 115
};
const stc47 = {
  "tab-empty-state-image": true
};
const stc48 = {
  classMap: {
    "empty-state": true
  },
  key: 119
};
const stc49 = [["--wds-modal-max-width", "600px", false]];
const stc50 = {
  "data-modal": "certifications"
};
const stc51 = {
  slotAssignment: "main-content",
  key: 125
};
const stc52 = {
  classMap: {
    "certifications-modal-table-wrapper": true
  },
  key: 131
};
const stc53 = {
  "certifications-modal-table": true
};
const stc54 = {
  key: 135
};
const stc55 = {
  "data-modal": "metrics"
};
const stc56 = {
  slotAssignment: "main-content",
  classMap: {
    "metrics-modal-content": true
  },
  key: 142
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, gid: api_scoped_id, ncls: api_normalize_class_name, ti: api_tab_index, k: api_key, b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, i: api_iterator, t: api_text, fr: api_fragment, f: api_flatten} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12, _m13, _m14, _m15, _m16, _m17, _m18, _m19} = $ctx;
  return [api_element("div", stc0, [$cmp.hasCompetencies ? api_fragment(1, [api_element("p", stc1, [api_custom_element("i18n-link", _i18nLink, {
    attrs: stc2,
    props: {
      "message": $cmp.i18n.listingDetails.competencies.intro,
      "target": "_blank"
    },
    key: 3
  })]), api_element("div", stc3, [api_element("div", {
    classMap: stc4,
    attrs: {
      "role": "tablist",
      "aria-label": $cmp.i18n.listingDetails.competencies.tabsAriaLabel
    },
    key: 5
  }, api_iterator($cmp.tabs, function (tab) {
    return api_static_fragment($fragment1, api_key(7, tab.key), [api_static_part(0, {
      on: {
        "click": _m2 || ($ctx._m2 = api_bind($cmp.handleTabSwitch)),
        "keydown": _m3 || ($ctx._m3 = api_bind($cmp.handleTabKeydown))
      },
      className: api_normalize_class_name(tab.tabClass),
      attrs: {
        "id": api_scoped_id(tab.id),
        "data-tab": tab.key,
        "data-testid": tab.testId,
        "aria-selected": tab.isActive,
        "aria-controls": api_scoped_id("competencies-tabpanel"),
        "tabindex": api_tab_index(tab.tabIndex)
      }
    }, null), api_static_part(1, null, api_dynamic_text(tab.label))]);
  })), api_element("div", stc5, [api_element("button", {
    classMap: stc6,
    attrs: {
      "type": "button",
      "data-testid": "metrics-info-trigger",
      "aria-label": $cmp.i18n.listingDetails.competencies.metricsTrigger.ariaLabel
    },
    key: 9,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.openMetricsModal))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc7), api_static_fragment($fragment2, 12, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.metricsTrigger.label))])])])]), api_element("div", {
    classMap: stc8,
    attrs: {
      "role": "tabpanel",
      "id": api_scoped_id("competencies-tabpanel"),
      "aria-labelledby": api_scoped_id($cmp.activeTabId)
    },
    key: 13
  }, [$cmp.hasActiveCompetencies ? api_fragment(14, [api_element("div", stc9, [api_element("table", {
    classMap: stc10,
    attrs: {
      "aria-label": $cmp.i18n.listingDetails.competencies.tableAriaLabel
    },
    key: 16
  }, api_flatten([api_element("thead", stc11, [api_element("tr", stc12, [api_static_fragment($fragment3, 20, [api_static_part(2, null, api_dynamic_text($cmp.categoryColumnHeader))]), api_element("th", stc13, [api_text(api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.competencyLevel)), api_element("span", stc14, [api_element("button", {
    classMap: stc15,
    attrs: {
      "data-tooltip": "competencyLevel",
      "data-testid": "tooltip-trigger-competencyLevel",
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipTriggerAriaLabels.competencyLevel,
      "aria-expanded": $cmp.showCompetencyLevelTooltip,
      "aria-describedby": api_scoped_id("tooltip-competencyLevel")
    },
    key: 23,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.toggleTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc16)]), $cmp.showCompetencyLevelTooltip ? api_fragment(25, [api_element("div", {
    classMap: stc17,
    attrs: {
      "id": api_scoped_id("tooltip-competencyLevel"),
      "role": "tooltip",
      "data-testid": "tooltip-competencyLevel"
    },
    key: 26
  }, [api_element("button", {
    classMap: stc18,
    attrs: {
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipCloseAriaLabel
    },
    key: 27,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.closeTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc19)]), api_static_fragment($fragment4, 30, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.intro))]), api_static_fragment($fragment5, 32, [api_static_part(4, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.accredited.name)), api_static_part(6, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.accredited.description))]), api_static_fragment($fragment6, 34, [api_static_part(4, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.expert.name)), api_static_part(6, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.expert.description))])])], 0) : null])]), api_element("th", stc20, [api_text(api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.recentProjects)), api_element("span", stc21, [api_element("button", {
    classMap: stc15,
    attrs: {
      "data-tooltip": "recentProjects",
      "data-testid": "tooltip-trigger-recentProjects",
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipTriggerAriaLabels.recentProjects,
      "aria-expanded": $cmp.showRecentProjectsTooltip,
      "aria-describedby": api_scoped_id("tooltip-recentProjects")
    },
    key: 37,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.toggleTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc22)]), $cmp.showRecentProjectsTooltip ? api_fragment(39, [api_element("div", {
    classMap: stc17,
    attrs: {
      "id": api_scoped_id("tooltip-recentProjects"),
      "role": "tooltip",
      "data-testid": "tooltip-recentProjects"
    },
    key: 40
  }, [api_element("button", {
    classMap: stc18,
    attrs: {
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipCloseAriaLabel
    },
    key: 41,
    on: {
      "click": _m8 || ($ctx._m8 = api_bind($cmp.closeTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc23)]), api_static_fragment($fragment7, 44, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tooltips.recentProjects))])])], 0) : null])]), api_element("th", stc24, [api_text(api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.avgCsat)), api_element("span", stc25, [api_element("button", {
    classMap: stc15,
    attrs: {
      "data-tooltip": "avgCsat",
      "data-testid": "tooltip-trigger-avgCsat",
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipTriggerAriaLabels.avgCsat,
      "aria-expanded": $cmp.showAvgCsatTooltip,
      "aria-describedby": api_scoped_id("tooltip-avgCsat")
    },
    key: 47,
    on: {
      "click": _m9 || ($ctx._m9 = api_bind($cmp.toggleTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc26)]), $cmp.showAvgCsatTooltip ? api_fragment(49, [api_element("div", {
    classMap: stc17,
    attrs: {
      "id": api_scoped_id("tooltip-avgCsat"),
      "role": "tooltip",
      "data-testid": "tooltip-avgCsat"
    },
    key: 50
  }, [api_element("button", {
    classMap: stc18,
    attrs: {
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipCloseAriaLabel
    },
    key: 51,
    on: {
      "click": _m10 || ($ctx._m10 = api_bind($cmp.closeTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc27)]), api_static_fragment($fragment8, 54, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tooltips.avgCsat))])])], 0) : null])]), api_element("th", stc28, [api_text(api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.certifications)), api_element("span", stc29, [api_element("button", {
    classMap: stc15,
    attrs: {
      "data-tooltip": "certifications",
      "data-testid": "tooltip-trigger-certifications",
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipTriggerAriaLabels.certifications,
      "aria-expanded": $cmp.showCertificationsTooltip,
      "aria-describedby": api_scoped_id("tooltip-certifications")
    },
    key: 57,
    on: {
      "click": _m11 || ($ctx._m11 = api_bind($cmp.toggleTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc30)]), $cmp.showCertificationsTooltip ? api_fragment(59, [api_element("div", {
    classMap: stc31,
    attrs: {
      "id": api_scoped_id("tooltip-certifications"),
      "role": "tooltip",
      "data-testid": "tooltip-certifications"
    },
    key: 60
  }, [api_element("button", {
    classMap: stc18,
    attrs: {
      "aria-label": $cmp.i18n.listingDetails.competencies.tooltipCloseAriaLabel
    },
    key: 61,
    on: {
      "click": _m12 || ($ctx._m12 = api_bind($cmp.closeTooltip))
    }
  }, [api_custom_element("ax-icon", _axIcon, stc32)]), api_static_fragment($fragment9, 64, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tooltips.certifications))])])], 0) : null])])])]), api_iterator($cmp.activeCompetencies, function (competency) {
    return api_element("tbody", {
      classMap: stc33,
      key: api_key(65, competency.id)
    }, [api_element("tr", stc34, [api_element("td", stc35, [competency.hasSpecializations ? api_fragment(68, [api_element("button", {
      classMap: stc36,
      attrs: {
        "data-testid": "expand-button",
        "data-id": competency.id,
        "aria-label": competency.expandAriaLabel,
        "aria-expanded": competency.isExpanded
      },
      key: 69,
      on: {
        "click": _m13 || ($ctx._m13 = api_bind($cmp.handleToggleRow))
      }
    }, [api_custom_element("ax-icon", _axIcon, {
      className: api_normalize_class_name(competency.expandIconClass),
      props: stc37,
      key: 70
    })])], 0) : null, api_static_fragment($fragment10, 72, [api_static_part(1, null, api_dynamic_text(competency.name))])]), api_element("td", stc38, [api_static_fragment($fragment11, 75, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.competencyLevel))]), api_element("span", stc39, [competency.hasCompetencyLevel ? api_fragment(77, [competency.isExpert ? api_fragment(78, [api_static_fragment($fragment12, 80)], 0) : null, competency.isAccredited ? api_fragment(81, [api_static_fragment($fragment13, 83)], 0) : null, api_static_fragment($fragment14, 85, [api_static_part(1, null, api_dynamic_text(competency.competencyLevelDisplay))])], 0) : null])]), api_static_fragment($fragment15, 87, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.recentProjects)), api_static_part(4, null, api_dynamic_text(competency.formattedNumProjects))]), api_static_fragment($fragment16, 89, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.avgCsat)), api_static_part(4, null, api_dynamic_text(competency.formattedAvgCsat))]), api_element("td", stc40, [api_static_fragment($fragment17, 92, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.certifications))]), api_element("span", stc41, [competency.numCertifications ? api_fragment(94, [api_static_fragment($fragment18, 96, [api_static_part(0, {
      on: {
        "click": _m15 || ($ctx._m15 = api_bind($cmp.openCertificationsModal))
      },
      attrs: {
        "data-competency-id": competency.id,
        "aria-label": competency.certificationsAriaLabel
      }
    }, null), api_static_part(1, null, api_dynamic_text(competency.formattedNumCertifications))])], 0) : api_fragment(94, [api_text(api_dynamic_text(competency.formattedNumCertifications))], 0)])])]), competency.isExpanded ? api_fragment(97, [competency.hasSpecializations ? api_fragment(98, api_iterator(competency.specializations, function (spec) {
      return api_element("tr", {
        classMap: stc42,
        attrs: stc43,
        key: api_key(99, spec.name)
      }, [api_static_fragment($fragment19, 101, [api_static_part(2, null, api_dynamic_text(spec.parentContext)), api_static_part(3, null, api_dynamic_text(spec.name))]), api_static_fragment($fragment20, 103), api_static_fragment($fragment21, 105, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.recentProjects)), api_static_part(4, null, api_dynamic_text(spec.formattedNumProjects))]), api_static_fragment($fragment22, 107, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.avgCsat)), api_static_part(4, null, api_dynamic_text(spec.formattedAvgCsat))]), api_element("td", stc44, [api_static_fragment($fragment23, 110, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.certifications))]), api_element("span", stc45, [spec.numCertifications ? api_fragment(112, [api_static_fragment($fragment24, 114, [api_static_part(0, {
        on: {
          "click": _m17 || ($ctx._m17 = api_bind($cmp.openCertificationsModal))
        },
        attrs: {
          "data-competency-id": competency.id,
          "data-subcategory-name": spec.name,
          "aria-label": spec.certificationsAriaLabel
        }
      }, null), api_static_part(1, null, api_dynamic_text(spec.formattedNumCertifications))])], 0) : api_fragment(112, [api_text(api_dynamic_text(spec.formattedNumCertifications))], 0)])])]);
    }), 0) : null], 0) : null]);
  })]))])], 0) : api_fragment(14, [api_element("div", stc46, [api_custom_element("ax-image", _axImage, {
    classMap: stc47,
    props: {
      "imgSrc": $cmp.emptyStateImg,
      "alt": ""
    },
    key: 116
  }), api_static_fragment($fragment25, 118, [api_static_part(1, null, api_dynamic_text($cmp.activeTabEmptyState))])])], 0)])], 0) : api_fragment(1, [api_element("div", stc48, [api_custom_element("ax-image", _axImage, {
    props: {
      "imgSrc": $cmp.errorEmptyStateImg,
      "alt": ""
    },
    key: 120
  }), api_static_fragment($fragment26, 122, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.emptyState))])])], 0), $cmp.showCertificationsModal ? api_fragment(123, [api_custom_element("wds-modal", _wdsModal, {
    styleDecls: stc49,
    attrs: stc50,
    props: {
      "title": $cmp.modalTitle,
      "closedFocusTarget": $cmp.certificationsModalTrigger,
      "bodyScroll": true,
      "hideFooterOnPhone": true
    },
    key: 124,
    on: {
      "close": _m18 || ($ctx._m18 = api_bind($cmp.handleCertificationsModalClose))
    }
  }, [api_element("div", stc51, [api_static_fragment($fragment27, 127, [api_static_part(1, null, api_dynamic_text($cmp.modalDescription))]), api_static_fragment($fragment28, 129, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.modal.totalCertifications)), api_static_part(4, null, api_dynamic_text($cmp.modalTotalCertifications))]), $cmp.hasCertificationsData ? api_fragment(130, [api_element("div", stc52, [api_element("table", {
    classMap: stc53,
    attrs: {
      "aria-label": $cmp.i18n.listingDetails.competencies.modal.certificationsTableAriaLabel
    },
    key: 132
  }, [api_static_fragment($fragment29, 134, [api_static_part(3, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.modal.certificationName)), api_static_part(5, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.modal.total))]), api_element("tbody", stc54, api_iterator($cmp.modalCertifications, function (cert) {
    return api_static_fragment($fragment30, api_key(137, cert.name), [api_static_part(2, null, api_dynamic_text(cert.name)), api_static_part(4, null, api_dynamic_text(cert.total))]);
  }))])])], 0) : api_fragment(130, [api_static_fragment($fragment31, 139, [api_static_part(1, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.modal.emptyState))])], 0)])])], 0) : null, $cmp.showMetricsModal ? api_fragment(140, [api_custom_element("wds-modal", _wdsModal, {
    styleDecls: stc49,
    attrs: stc55,
    props: {
      "title": $cmp.metricsModalTitle,
      "closedFocusTarget": $cmp.metricsModalTrigger,
      "bodyScroll": true,
      "hideFooterOnPhone": true
    },
    key: 141,
    on: {
      "close": _m19 || ($ctx._m19 = api_bind($cmp.handleMetricsModalClose))
    }
  }, [api_element("div", stc56, [api_static_fragment($fragment32, 144, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.competencyLevel)), api_static_part(4, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.intro)), api_static_part(9, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.accredited.name)), api_static_part(11, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.accredited.description)), api_static_part(16, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.expert.name)), api_static_part(18, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.levels.expert.description))]), api_static_fragment($fragment33, 146, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.recentProjects)), api_static_part(4, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tooltips.recentProjects))]), api_static_fragment($fragment34, 148, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.avgCsat)), api_static_part(4, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tooltips.avgCsat))]), api_static_fragment($fragment35, 150, [api_static_part(2, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tableHeaders.certifications)), api_static_part(4, null, api_dynamic_text($cmp.i18n.listingDetails.competencies.tooltips.certifications))])])])], 0) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2s2f5bj2ajd";
tmpl.legacyStylesheetToken = "undefined-_competenciesV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
